<template>
    <span :class="spinnerClasses" role="status" :aria-label="label || null">
        <span v-if="label" class="sr-only">{{ label }}</span><slot />
    </span>
</template>
<script>
export default {
    name: "SbSpinner",
    props: {
        type: { type: String, default: "border" },
        small: { type: Boolean, default: false },
        label: { type: String, default: null },
    },
    computed: {
        spinnerClasses() {
            return [`spinner-${this.type}`, this.small && `spinner-${this.type}-sm`];
        },
    },
};
</script>
